import React from 'react'
import { useState } from 'react';
import { Button, Grid, Paper, TextField, Alert, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { api_url } from '../config';

const ApiButtonComp = ({ setState, setMessage, setMsg, month, title, id, setLoader }) => {

    const handleUpload = async (event) => {
        try {
            setMsg(false);
            console.log(1);
            const { name } = event.target.files[0];

            // console.log(tree_id);

            if (month.length === 0) {
                alert('Select Month');
                return false;
            }
            else {

                setLoader(true);
                const data = new FormData();
                data.append('file', event.target.files[0]);
                console.log(data);
                const { data: obj } = await axios.post(`${api_url}/mission-vriksh-uploadFileAPI`, data)

                if (obj.success == 'ok') {

                    setState(obj.url);
                    setMessage(`${title} uploaded`);
                    setMsg(true);
                }

            }
        }
        catch (e) {
            alert(e.message);
        }
        finally {
            setLoader(false);
        }
    }


    return (
        <>
            <input type="file" id={"contained-button-file-" + id} accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" style={{ display: 'none' }} onChange={handleUpload} />
            <label htmlFor={"contained-button-file-" + id} style={{ display: 'inline' }}>
                <Button style={{ color: '#2a7e19' }} fullWidth variant="outined"
                    startIcon={<CloudUploadIcon />}
                    component="span">
                    {title}
                </Button>
            </label>
        </>
    )
}

export default ApiButtonComp
